import { Link } from 'react-router-dom';
import LogoTitle from '../../assets/images/logo-rr.png';
import './index.scss';
import AnimatedLetter from '../AnimatedLetters';
import { useEffect, useState } from 'react';
import Logo from './Logo';
import Loader from 'react-loaders'; 

const Home = () => {
    const [letterClass, setletterClass] = useState('text-animate')
    const nameArray = ['u', 'd', 'r', 'a']
    const jobArray = ['W', 'e', 'b', ' ', 'D', 'e', 'v', 'e', 'l', 'o', 'p', 'e', 'r', '.']

    useEffect(() => {
        setTimeout(() => {
            setletterClass('text-animate-hover')
      }, 4000);
    }, [])
    
    

    return (
        <>
        <div className="container home-page">
            <div className="text-zone">
                <h1>
                <span className={letterClass}>H</span>
                <span className={`${letterClass} _12`}>i,</span>
                <br />
                <span className={`${letterClass} _13`}>I</span>
                <span className={`${letterClass} _14`}>'</span>
                <span className={`${letterClass} _15`}>m</span>
                <img src={LogoTitle} alt="developer" />
                <AnimatedLetter  letterClass={letterClass} 
                    strArray={nameArray} idx={16}
                />
                <br />
                <AnimatedLetter letterClass={letterClass} 
                    strArray={jobArray} idx={20}
                />
                </h1>
                <h2>Frontend Developer / Graphic Designer</h2>
                <Link to="/contact" className='flat-button'>CONTACT ME</Link>
                <Link to="https://drive.google.com/file/d/1llD5A-iErRBg7utyy8WPgN8RucP8Cgxi/view?usp=sharing" className='flat-button' target="_blank" rel="noreferrer">DOWNLOAD RESUME</Link>
            </div>
            <Logo />
        </div>
        <Loader type='pacman' />
        </>
    );
}

export default Home;